/**
 * @Author: v_jppjpeng
 * @Date: 2024-12-09 15:34:45
 * @Explain: 时间范围选择
 */
import { Icon } from '@/components/tdesign';
import {
  DateRangePickerProps,
  DateRangePicker as TdDateRangePicker,
} from 'tdesign-react';
// utils
import { scDateFormat } from '@/utils/format/time';
// type
import classNames from 'classnames';
import { InputSizeEnum } from '../data.d';

type PropsType = {
  className?: DateRangePickerProps['className'];
  style?: DateRangePickerProps['style'];
  disableDate?: any;
  size?: InputSizeEnum;
  presetsPlacement?: DateRangePickerProps['presetsPlacement'];
  value?: DateRangePickerProps['value'];
  onChange?: DateRangePickerProps['onChange'];
};

function DateRangePicker(props: PropsType) {
  const {
    className,
    style,
    size = InputSizeEnum.M,
    presetsPlacement,
    value = [],
    onChange,
    disableDate,
  } = props;
  return (
    <TdDateRangePicker
      disableDate={disableDate}
      className={classNames(
        'default-td-date-range-picker',
        { [`size-${size}`]: size },
        className,
      )}
      style={style}
      presetsPlacement={presetsPlacement}
      format={scDateFormat({ showHMS: false })}
      suffixIcon={<Icon.Font name="date-picker" fontSize={24} />}
      value={value}
      onChange={onChange}
    />
  );
}

export default DateRangePicker;
